// extracted by mini-css-extract-plugin
export default {"guide-body":"IsSREEkQQKBCKbNzP5gh","guide-image":"noCYkN8vbGhLkJCngTox"};